// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";

var ztp_pdf_link = "https://drive.google.com/viewerng/viewer?embedded=true&url=https://dom-website-prod-cdn-web.porter.in/zero_tolerance_policy.pdf";

function footer_link_transform(title, link) {
  return {
          title: title,
          link: link
        };
}

function get_company_internal_links(param) {
  return {
          title: "Company",
          links: [
            {
              title: "About Us",
              link: "/about-us"
            },
            {
              title: "Careers",
              link: "/careers"
            },
            {
              title: "Blog",
              link: "/blog"
            }
          ]
        };
}

function get_support_links(param) {
  return {
          title: "Support",
          links: [
            {
              title: "Contact Us",
              link: "/support"
            },
            {
              title: "Privacy Policy",
              link: "/privacy-policy"
            },
            {
              title: "Terms of Service",
              link: "/terms-of-service"
            },
            {
              title: "Terms of Service - SSI",
              link: "/terms-of-service-ssi"
            },
            {
              title: "Insurance FAQs",
              link: "/insurance-faq"
            },
            {
              title: "Driver Partner Terms & Conditions",
              link: "/terms-of-service/partners"
            },
            {
              title: "Zero Tolerance Policy",
              link: ztp_pdf_link
            }
          ]
        };
}

function get_services_links(param) {
  return {
          title: "Quick Links",
          links: [
            {
              title: "API Integrations",
              link: "/api-integrations"
            },
            {
              title: "InterCity Courier",
              link: "/courier"
            },
            {
              title: "Packers & Movers",
              link: "/packers-and-movers"
            },
            {
              title: "Two Wheelers",
              link: "/two-wheelers"
            },
            {
              title: "Trucks",
              link: "/trucks"
            },
            {
              title: "Porter Enterprise",
              link: "/enterprise"
            }
          ]
        };
}

function get_city_truck_links(param) {
  return {
          title: "Domestic Cities",
          links: [
            {
              title: "Delhi NCR",
              link: Config$PorterinUtils.oms_url + "/trucks/delhi"
            },
            {
              title: "Hyderabad",
              link: Config$PorterinUtils.oms_url + "/trucks/hyderabad"
            },
            {
              title: "Bangalore",
              link: Config$PorterinUtils.oms_url + "/trucks/bangalore"
            },
            {
              title: "Mumbai",
              link: Config$PorterinUtils.oms_url + "/trucks/mumbai"
            },
            {
              title: "Vadodara",
              link: Config$PorterinUtils.oms_url + "/trucks/vadodara"
            },
            {
              title: "Chandigarh",
              link: Config$PorterinUtils.oms_url + "/trucks/chandigarh"
            },
            {
              title: "Jaipur",
              link: Config$PorterinUtils.oms_url + "/trucks/jaipur"
            },
            {
              title: "Chennai",
              link: Config$PorterinUtils.oms_url + "/trucks/chennai"
            },
            {
              title: "Kolkata",
              link: Config$PorterinUtils.oms_url + "/trucks/kolkata"
            },
            {
              title: "Indore",
              link: Config$PorterinUtils.oms_url + "/trucks/indore"
            },
            {
              title: "Ahmedabad",
              link: Config$PorterinUtils.oms_url + "/trucks/ahmedabad"
            },
            {
              title: "Surat",
              link: Config$PorterinUtils.oms_url + "/trucks/surat"
            },
            {
              title: "Nagpur",
              link: Config$PorterinUtils.oms_url + "/trucks/nagpur"
            },
            {
              title: "Lucknow",
              link: Config$PorterinUtils.oms_url + "/trucks/lucknow"
            },
            {
              title: "Pune",
              link: Config$PorterinUtils.oms_url + "/trucks/pune"
            },
            {
              title: "Coimbatore",
              link: Config$PorterinUtils.oms_url + "/trucks/coimbatore"
            },
            {
              title: "Ludhiana",
              link: Config$PorterinUtils.oms_url + "/trucks/ludhiana"
            },
            {
              title: "Kochi",
              link: Config$PorterinUtils.oms_url + "/trucks/kochi"
            },
            {
              title: "Nashik",
              link: Config$PorterinUtils.oms_url + "/trucks/nashik"
            },
            {
              title: "Kanpur",
              link: Config$PorterinUtils.oms_url + "/trucks/kanpur"
            },
            {
              title: "Visakhapatnam",
              link: Config$PorterinUtils.oms_url + "/two-wheelers/visakhapatnam"
            },
            {
              title: "Trivandrum",
              link: Config$PorterinUtils.oms_url + "/two-wheelers/trivandrum"
            }
          ]
        };
}

var copyright_info = "© " + String(new Date(Date.now()).getFullYear()) + " SmartShift Logistics Solutions Pvt. Ltd.";

var company_internal_links = get_company_internal_links(undefined);

var support_links = get_support_links(undefined);

var services_links = get_services_links(undefined);

var city_truck_links = get_city_truck_links(undefined);

var insta_link = "https://www.instagram.com/porter_it/";

var fb_link = "https://www.facebook.com/porterindia/";

var linkedIn_link = "https://www.linkedin.com/company/theporter-in";

var yt_link = "https://www.youtube.com/channel/UC6eokjbxNMN2WQNgyZElNeA/feed";

var twitter_link = "https://twitter.com/porterit_";

var androidLinkUrl = "https://porter.in/android-app";

var iosLinkUrl = "https://apps.apple.com/in/app/porter-hire-a-mini-truck/id1109398410";

var porter_rating = "https://nest-platform-assets.porter.in/download_app_icon_v2_75a896e37e/download_app_icon_v2_75a896e37e.svg";

var cnn = "U74999MH2014PTC306120";

var email = "help@theporter.in";

var phone = "080 4410 4410";

var motto = "Send anything, anywhere, anytime";

var follow_us = "Follow us on";

var follow_us_bd = "আমাদের অনুসরণ করুন:";

var follow_us_tr = "Bizi takip edin:";

var download_app = "Download our app now!";

var download_app_bd = "এখনই আমাদের অ্যাপটি ডাউনলোড করুন!";

var download_app_tr = "Uygulamamızı hemen indirin!";

var scan_qr_code_to_download = "Scan the QR Code to download";

var scan_qr_code_to_download_bd = "ডাউনলোড করতে কিউআর কোড স্ক্যান করুন";

var scan_qr_code_to_download_tr = "İndirmek için QR Kodunu tarayın";

var ga_footer_download_android = "Android Download - Footer";

var ga_footer_download_ios = "iOS Download - Footer";

var company_legal_info = "No. A-501, A-502, B-504, B-505 and B-506, Fifth Floor at Universal Business Park, Chandivali Farm Road, off. Saki Vihar Road, Andheri (East), Mumbai-4000072, Maharastra";

export {
  insta_link ,
  fb_link ,
  linkedIn_link ,
  yt_link ,
  twitter_link ,
  androidLinkUrl ,
  iosLinkUrl ,
  porter_rating ,
  cnn ,
  email ,
  phone ,
  ztp_pdf_link ,
  footer_link_transform ,
  get_company_internal_links ,
  get_support_links ,
  get_services_links ,
  get_city_truck_links ,
  copyright_info ,
  motto ,
  follow_us ,
  follow_us_bd ,
  follow_us_tr ,
  download_app ,
  download_app_bd ,
  download_app_tr ,
  scan_qr_code_to_download ,
  scan_qr_code_to_download_bd ,
  scan_qr_code_to_download_tr ,
  company_internal_links ,
  support_links ,
  services_links ,
  city_truck_links ,
  ga_footer_download_android ,
  ga_footer_download_ios ,
  company_legal_info ,
}
/* copyright_info Not a pure module */
